import React from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import { trimQuantity } from "../../../Investments/utils";
import { Caption } from "../../styles";
import { ShareFigure, SharePreview } from "../styles";
import { CorporateActionPreviewProps } from "../types";

export const CorporateActionPreview: React.FC<CorporateActionPreviewProps> = ({
  action: {
    isEffective,
    preview: { openHoldings, currentShares, projectedShares },
  },
}) => {
  if (currentShares === null || openHoldings === 0) {
    return null;
  }

  const current = trimQuantity(currentShares);

  if (isEffective) {
    return (
      <SharePreview>
        <ShareFigure>
          <strong>{current}</strong>
          Total shares · split already applied
        </ShareFigure>
      </SharePreview>
    );
  }

  if (projectedShares === null) {
    return (
      <>
        <SharePreview>
          <ShareFigure>
            <strong>{current}</strong>
            Total shares today
          </ShareFigure>
        </SharePreview>
        <Caption>
          At least one holding won't split exactly, so no projected total is
          shown. Its owner settles the fractional share.
        </Caption>
      </>
    );
  }

  return (
    <SharePreview>
      <ShareFigure>
        <strong>{current}</strong>
        Total shares today
      </ShareFigure>
      <ArrowForwardRoundedIcon aria-hidden="true" fontSize="small" />
      <ShareFigure>
        <strong>{trimQuantity(projectedShares)}</strong>
        Total shares after the split
      </ShareFigure>
    </SharePreview>
  );
};
